function getVariant(estado) {
  switch (estado) {
    case "Aprobado":
      return "bg-[#10BB10]";
    case "Legalizado":
      return "bg-[#10BB10]";
    case "Inmovilizado":
      return "bg-[#FFCC10]";
    case "Rechazado":
      return "bg-[#FF2020]";
    case "Pendiente de Inspección":
      return "bg-[#ff7010]";
    case "Presentado":
      return "bg-[#5040FF]";
    case "Pendiente":
      return "bg-[#AAAAAA]";
    case "Retención":
      return "bg-[#AAAAAA]";
    case "Retirado con multa":
      return "bg-[#FF4020]";
    case "Retirado":
      return "bg-[#FF4020]";
    case "Sin observaciones":
      return "bg-[#30BBEE]";
    default:
      return "bg-primary";
  }
}

function getTextVariant(estado) {
  switch (estado) {
    case "Aprobado":
      return "text-[#10BB10]";
    case "Legalizado":
      return "text-[#10BB10]";
    case "Inmovilizado":
      return "text-[#FFCC10]";
    case "Rechazado":
      return "text-[#FF2020]";
    case "Pendiente de Inspección":
      return "text-[#ff7010]";
    case "Presentado":
      return "text-[#3090FF]";
    case "Pendiente":
      return "text-[#AAAAAA]";
    case "Retención":
      return "text-[#AAAAAA]";
    case "Retirado con multa":
      return "text-[#FF4020]";
    case "Retirado":
      return "text-[#FF4020]";
    case "Sin observaciones":
      return "text-[#30BBEE]";
    default:
      return "text-primary";
  }
}

function getColorVariant(estado) {
  switch (estado) {
    case "Aprobado":
      return "#10BB10";
    case "Legalizado":
      return "#10BB10";
    case "Inmovilizado":
      return "#FFCC10";
    case "Rechazado":
      return "#FF2020";
    case "Pendiente de Inspección":
      return "#ff7010";
    case "Presentado":
      return "#3090FF";
    case "Pendiente":
      return "#AAAAAA";
    case "Retención":
      return "#AAAAAA";
    case "Retirado con multa":
      return "#FF4020";
    case "Retirado":
      return "#FF4020";
    case "Sin observaciones":
      return "#30BBEE";
  }
}

export { getVariant, getTextVariant, getColorVariant };
